import { SVGProps } from 'react';

const LicensePlateIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg height="20" width="20" fill="none" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path d="M5 10.8333L5 9.16668" stroke="currentColor" strokeLinecap="round" strokeWidth="1.25" />
      <path d="M7.5 10.8333L7.5 9.16668" stroke="currentColor" strokeLinecap="round" strokeWidth="1.25" />
      <path d="M10 10.8333L10 9.16668" stroke="currentColor" strokeLinecap="round" strokeWidth="1.25" />
      <path d="M12.5 10.8333L12.5 9.16668" stroke="currentColor" strokeLinecap="round" strokeWidth="1.25" />
      <path d="M15 10.8333L15 9.16668" stroke="currentColor" strokeLinecap="round" strokeWidth="1.25" />
      <rect
        height="10"
        width="15"
        rx="1.66667"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.25"
        x="2.5"
        y="5"
      />
    </svg>
  );
};

export default LicensePlateIcon;
